module.exports = __webpack_public_path__ + "img/coin98.af244383.png";